<template lang="pug">
.text-muted.m-4(v-if="!account && !failed")
    img.mr-3(
        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
    )
    | Ihre Kontodaten werden geladen

.text-danger.m-4(v-else-if="failed")
    | Ihre Kontodaten konnten nicht geladen werden. Ihnen fehlt eventuell die Berechtigung.

form(v-else-if="account", @submit.prevent="updateAccount")
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 Firmenname
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.name", required)
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 Straße
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.address.street")
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 Postleitzahl
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.address.zip")
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 Ort
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.address.city")
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 Telefonnummer
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.contact.phone")
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 Faxnummer
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.contact.fax")
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 E-Mail
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.contact.email")
    .form-group.row
        label.col-form-label.col-sm-4.col-lg-2 Webseite
        .col-sm-8.col-lg-10
            input.form-control(v-model="account.contact.website")
    .text-right
        button.btn.btn-primary(type="submit") Speichern
</template>

<script>
import { accountService } from '@/services'

export default {
    data () {
        return {
            account: null,
            failed: null
        }
    },
    async mounted () {
        const user = this.$store.state.authentication.user
        try {
            this.account = await accountService.get(user.account.id)
        } catch (err) {
            this.failed = true
        }
    },
    methods: {
        updateAccount () {
            accountService.update(this.account.id, this.account).then((response) => {
                this.$store.dispatch('alert/success', 'Kontoeinstellungen erfolgreich aktualisiert')
            }, (error) => {
                this.$store.dispatch('alert/error', 'Kontoeinstellungen konnten nicht gespeichert werden (' + error.message + ')')
            })
        }
    }
}
</script>
